<template>
<div>
    <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'"> {{$t('form.sous_categ.sous_categorie')}} </h1>
    <sav-fold-card v-model="open" class="mt-4" :close-button="false" :can-open="canOpen"  :id="$options.name">
        <template v-slot:close>
            <span class="font-bold" v-if="selected">{{selected.label}}</span>
        </template>
        <template v-slot:open>
            <sav-spinner v-if="loading" :size="10" />
            <list-items v-if="data" :data-src="data" :callback="end" :id="$options.name"></list-items>
        </template>
    </sav-fold-card>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'subcategory',
    extends: FormCardExtension,

    methods: {
        async init() {
            this.loading = true

            // Get api data
            let response = await apiService.post('getcateg', {
                id_group: this.$formTool.getFormData('category').id,
                marque: this.$formTool.getFormData('brand').label,
                // id_fam: this.getBlock('family').result ? this.getBlock('family').result.id : null
            })

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            this.data = this.$imgGridTool.convert('name', 'img', response.data.posts.post)

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.nextBlock = this.getNextBlock()
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
            }

            if (!this.data || this.data.length <= 0) {
                this.$parent.removeLastBlock()
                this.nextBlock = this.$formTool.blockData(this.$options.name).next.noData
                this.emitChange()
            }
            
            this.loading = false
        },

        end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            this.nextBlock = this.getNextBlock()
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
        },

        getNextBlock() {
            if (!this.data || this.data.length <= 0) {
                this.$parent.removeLastBlock()
                return this.$formTool.blockData(this.$options.name).next.noData
            } else {
                return this.$formTool.blockData(this.$options.name).next.data
            }
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/product/SubCategoryCard.vue